export default __webpack_public_path__ + "f70f3b0ceb1ce946f7707f434a462f61.png";